<template>
    <div class="app-header bg-[#0e0e0c] min-h-[64px] h-[64px]">
        <layout-contained class="h-full">
            <div class="h-full flex flex-row">
                <app-header-logo class="grow lg:grow-0"></app-header-logo>
                <app-header-menu class="hidden lg:flex grow ml-12"></app-header-menu>
                <app-header-me v-if="isLoggedIn" class="flex px-4 py-2"></app-header-me>
                <app-header-login v-else class="hidden py-2 md:flex md:gap-x-4"></app-header-login>
                <app-header-hamburger-menu></app-header-hamburger-menu>
                <app-header-search v-if="$route.name !== 'search'"></app-header-search>
                <app-header-hamburger class="py-2 pl-2" :unreadCount="unreadCount"></app-header-hamburger>
            </div>
        </layout-contained>
    </div>
</template>

<script>
import {mapState} from 'pinia';

export default {
    name: 'AppHeader',
    computed: {
        ...mapState(useStoreAuth, {
            isLoggedIn: 'isLoggedIn',
        }),
        ...mapState(useStoreThreadsUnread, {
            unreadCount: 'unreadCount',
        }),
    },
};
</script>
